import RadioButton from './RadioButton'
import { forwardRef } from 'react'
import { preventDefault } from '../../utils'
import type { RadioButtonProps } from './types'

const ClientRadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(function ClientRadioButton(
  { onChange: onChange_, onClick: onClick_, ...props },
  ref
) {
  const { disabled } = props
  const onChange = disabled ? preventDefault : onChange_
  const onClick = disabled ? preventDefault : onClick_
  return <RadioButton {...props} onChange={onChange} onClick={onClick} ref={ref} />
})

export default ClientRadioButton
